<template>
  <component
    :is="tag"
    :class="[
      theme,
      'border-l-[0.375rem] pl-2 py-1 empty:hidden leading-6',
      {
        'border-semantic-inverse-primary text-semantic-inverse-on-surface': variant === 'inverted',
        'border-semantic-primary-default text-semantic-surface-on-surface': variant === 'default',
        'border-semantic-states-success-default text-semantic-surface-on-surface': variant === 'success',
        'border-semantic-states-warning-default text-semantic-surface-on-surface': variant === 'warning'
      }
    ]"
  >
    <slot v-if="$slots.default"></slot>
  </component>
</template>

<script setup>
defineOptions({
  name: 'AtomsHeadline'
})

defineProps({
  tag: {
    type: String,
    default: 'h2',
    validator: value => {
      if (value.indexOf('h') === 0 && value.length === 2) {
        return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value)
      }

      return value
    }
  },

  theme: {
    type: String,
    default: ''
  },

  variant: {
    type: String,
    default: 'default',
    validator: value => ['default', 'inverted', 'warning', 'success'].includes(value)
  }
})
</script>
